// Import jQuery (Ensure jQuery is installed via npm or included appropriately)
import $ from "jquery";

$(document).ready(function(){
    // Function to format number with commas
    function formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    // Function to generate a random duration between min and max (in milliseconds)
    function getRandomDuration(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // Function to animate numbers
    function animateNumber($element) {
        // Extract the numeric value, removing any commas
        var finalValue = parseInt($element.text().replace(/,/g, ''), 10);

        // Calculate half of the final value and round it
        var halfValue = Math.round(finalValue / 2);

        // Initialize the display with the half value
        $element.text(formatNumber(halfValue));

        // Generate a random duration between 3000ms (3s) and 5000ms (5s)
        var randomDuration = getRandomDuration(3000, 5000);

        // Animate from half to full value with random duration
        $({countNum: halfValue}).animate({countNum: finalValue}, {
            duration: randomDuration, // Randomized duration for slower animation
            easing: 'swing', // Easing function
            step: function(now) {
                // Update the text with the current animated number, formatted with commas
                $element.text(formatNumber(Math.floor(now)));
            },
            complete: function() {
                // Ensure the final value is correctly displayed
                $element.text(formatNumber(finalValue));
            }
        });
    }

    // Function to check if IntersectionObserver is supported
    function isIntersectionObserverAvailable() {
        return 'IntersectionObserver' in window;
    }

    if (isIntersectionObserverAvailable()) {
        // Select all <skinny> elements inside .stat_card h1
        const targets = document.querySelectorAll('.stat_card h1 skinny');

        // Create a new IntersectionObserver instance
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When the element enters the viewport, animate the number
                    const $skinny = $(entry.target);
                    
                    // Animate the number
                    animateNumber($skinny);
                }
            });
        }, {
            threshold: 0.5 // Trigger when 50% of the element is visible
        });

        // Observe each target
        targets.forEach(target => {
            observer.observe(target);
        });
    } else {
        // Fallback for browsers that do not support IntersectionObserver
        // Simply animate all numbers on page load with random durations
        $('.stat_card h1 skinny').each(function(){
            var $this = $(this);
            animateNumber($this);
        });
    }
});
